import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieManagementService } from '../../account/services/cookie-management.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppConfig } from '../../config-service/app.config';

@Injectable()
export class Service3dsRequest {
  accessToken = '';

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private cookieManagementService: CookieManagementService
  ) { }

  public service3dsRequest(url: string, body: string) {
    this.accessToken = this.cookieManagementService.getAccessToken();
    if (this.accessToken == '') {
      console.log('Giriş Yapınız!!!');
      return null;
    } else {
      this.accessToken = 'Bearer ' + this.accessToken;

      let headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      });

      body = `url=${url}&` + body;

      return this.http
        //.post(url, body, {
        .post("/app/card-operations/services/3dsRequest.php", body, {
          headers: headers,
          responseType: 'text',
        })
        .pipe(
          map((res) => {
            return { html: res };
          }),
          catchError((error) => {
            if (typeof error === 'string') {
              return throwError(error);
            } else {
              return throwError(
                this.translate.instant('DEFAULT_ERROR_MESSAGE')
              );
            }
          })
        );
    }
  }
}

